class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M10.7 2.63 8.283.959a.5.5 0 0 0-.569 0L5.301 2.63H4.5a1 1 0 0 0-1 1v.247L1.473 5.28A1 1 0 0 0 1 6.13v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-.454-.838L12.5 3.876V3.63a1 1 0 0 0-1-1h-.8Zm-3.642 0h1.884L8 1.978l-.942.652ZM12.5 5.092v1.314l.95-.657-.95-.657Zm-1 2.007V3.63h-7v3.469L8 9.522l3.5-2.423Zm-8-.692V5.093l-.949.657.949.657Zm10.5.177-5.715 3.957a.5.5 0 0 1-.57 0L2 6.584v7.546h12V6.584Z" clip-rule="evenodd"></path><path d="M5.5 4.63h3v1h-3v-1Zm0 2h5v1h-5v-1Z"></path></svg>';
  }
}
const e = "pi-subscription";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
